export const environment = {
  production: true,
  apiUrl: 'https://staging.internal-api.moveup.care',
  authServiceUrl: 'https://staging.auth-service.moveup.care',
  clientId: 'cm7vx353i00003b6msnsqxnxz',
};
